import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { TeamDetailSliceProps, TeamDetailsResponse } from "../../type";
import { get } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const getTeamDetails = createAsyncThunk(
  "admin/teams",
  async (params: TeamDetailSliceProps, storeActions) => {
    const url = `api/v1/admin/teams/${params.teamId}`;
    const response: any = await get(url, storeActions);
    
    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.json(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const teamDetailsSlice = createSlice({
  name: "teamDetails",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    text: null as string | null,
    data: null as TeamDetailsResponse | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTeamDetails.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
    });
    builder.addCase(getTeamDetails.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = state.data ? state.data : null;
      state.text = null;
    });
    builder.addCase(getTeamDetails.rejected, (state) => {
      state.status = HttpStatus.SERVICE_UNAVAILABLE;
      state.loading = false;
      state.data = null;
      state.text = null;
    });
  },
});

export const { clearData } = teamDetailsSlice.actions;

export default teamDetailsSlice;

